export const CONSTANTS = {
    // super-admin-backend: GraphQL and the REST API (price-list uploads).
    API_URI: process.env.REACT_APP_API_URI,
    REST_API_URI: process.env.REACT_APP_REST_API_URI,
    PUBLIC_API_URL: process.env.REACT_APP_PUBLIC_API_URL,
    // The regular Denthub app, opened in a new tab when impersonating a user.
    REACT_APP_URI: process.env.REACT_APP_URI,
    DEPLOY_ENV: process.env.REACT_APP_DEPLOY_ENV || 'local',
    GOOGLE_PLACES_API_BASE_URL: process.env.REACT_APP_GOOGLE_PLACES_API_BASE_URL,
    GOOGLE_PLACES_API_KEY: process.env.REACT_APP_GOOGLE_PLACES_API_KEY,
    // The regular app's session cookies, written when impersonating (see open-impersonation-session).
    TOKEN_KEY: 'token',
    LAB_ID_KEY: 'current-lab-id',
    SETTINGS_NAMES: {
        ISOLATED_USERS: 'ISOLATED_USERS',
        VISMA: 'VISMA',
    },
    TRANSPORT_TIME: {
        time: '14',
        PICKUP: 11, //11 am
        DELIVERY: 18, // 5:30 pm
    },
    HOLIDAYS: [
        new Date('2023-01-01').setHours(0, 0, 0, 0),
        new Date('2023-01-06').setHours(0, 0, 0, 0),
        new Date('2023-04-07').setHours(0, 0, 0, 0),
        new Date('2023-04-09').setHours(0, 0, 0, 0),
        new Date('2023-04-10').setHours(0, 0, 0, 0),
        new Date('2023-05-01').setHours(0, 0, 0, 0),
        new Date('2023-05-18').setHours(0, 0, 0, 0),
        new Date('2023-05-28').setHours(0, 0, 0, 0),
        new Date('2023-06-06').setHours(0, 0, 0, 0),
        new Date('2023-06-24').setHours(0, 0, 0, 0),
        new Date('2023-11-04').setHours(0, 0, 0, 0),
        new Date('2023-12-25').setHours(0, 0, 0, 0),
        new Date('2023-12-26').setHours(0, 0, 0, 0),

        new Date('2024-01-01').setHours(0, 0, 0, 0),
        new Date('2024-01-06').setHours(0, 0, 0, 0),
        new Date('2024-03-29').setHours(0, 0, 0, 0),
        new Date('2024-03-31').setHours(0, 0, 0, 0),
        new Date('2024-04-01').setHours(0, 0, 0, 0),
        new Date('2024-05-01').setHours(0, 0, 0, 0),
        new Date('2024-05-09').setHours(0, 0, 0, 0),
        new Date('2024-05-19').setHours(0, 0, 0, 0),
        new Date('2024-06-06').setHours(0, 0, 0, 0),
        new Date('2024-06-22').setHours(0, 0, 0, 0),
        new Date('2024-11-02').setHours(0, 0, 0, 0),
        new Date('2024-12-25').setHours(0, 0, 0, 0),
        new Date('2024-12-26').setHours(0, 0, 0, 0),

        new Date('2025-01-01').setHours(0, 0, 0, 0),
    ],
    TRANSPORT_DEADLINES: [
        'No Deadline',
        '8:00',
        '8:30',
        '9:00',
        '9:30',
        '10:00',
        '10:30',
        '11:00',
        '11:30',
        '12:00',
        '12:30',
        '13:00',
        '13:30',
        '14:00',
    ],
    COOKIE_OPTIONS: {
        path: '/',
        sameSite: 'strict' as const,
        domain:
            process.env.REACT_APP_DEPLOY_ENV === 'production' || process.env.REACT_APP_DEPLOY_ENV === 'staging'
                ? '.denthub.com'
                : 'localhost',
        secure: true,
    },
    TEMPLATE_NAME: [
        {
            key: 'ACTION_BASED_CLIENT_ACTION_PRICE_LIST',
            value: 'action-based-client-action-price-list',
        },
        {
            key: 'ACTION_PRICE_LIST',
            value: 'action-price-list',
        },
        {
            key: 'CERTIFICATION',
            value: 'certification',
        },
        {
            key: 'CLIENT_LIST',
            value: 'client-list',
        },
        {
            key: 'COLLECTIVE_INVOICES',
            value: 'collective-invoices',
        },
        {
            key: 'CREDIT_INVOICES',
            value: 'credit-invoices',
        },
        {
            key: 'DEADLINE_SCHEDULE',
            value: 'deadline-schedule',
        },
        {
            key: 'DELIVERY_NOTES',
            value: 'delivery-notes',
        },
        {
            key: 'DESTINATION_ADDRESS_LABEL',
            value: 'destination-address-label',
        },
        {
            key: 'DEVIATION_REPORT',
            value: 'deviation-report',
        },
        {
            key: 'INVOICE_SPECIFICATION',
            value: 'invoice-specification',
        },
        {
            key: 'MATERIAL_LIST',
            value: 'material-list',
        },
        {
            key: 'MATERIAL_PRICE_LIST',
            value: 'material-price-list',
        },
        {
            key: 'ORDER_FORM',
            value: 'order-form',
        },
        {
            key: 'ORDER_RECEIPT',
            value: 'order-receipt',
        },
        {
            key: 'ORDER_SUMMARY',
            value: 'order-summary',
        },
        {
            key: 'PATIENT_LABEL',
            value: 'patient-label',
        },
        {
            key: 'PATIENT_SPECIFICATION',
            value: 'patient-specification',
        },
        {
            key: 'SINGLE_INVOICES',
            value: 'single-invoices',
        },
        {
            key: 'TRANSPORT_INVOICE_SPECIFICATION',
            value: 'transport-invoice-specification',
        },
        {
            key: 'TRANSPORT_SCHEDULE',
            value: 'transport-schedule',
        },
        {
            key: 'WORK_SHEET',
            value: 'work-sheet-v2',
        },
        {
            key: 'WORK_SHEET_SUBCONTRACTOR',
            value: 'work-sheet-subcontractor',
        },
    ],
};
